import React from 'react';
import {
  Grid,
  Button,
  TextField,
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  ExpansionPanelActions,
  Card,
  CardContent,
  CardMedia
} from '@material-ui/core'
import {
  ExpandMore as ExpandMoreIcon,
} from '@material-ui/icons';

import { Helmet } from 'react-helmet';

// import 'video-react/dist/video-react.css';
// import Player from '../../components/Player';

import ReactResizeDetector from 'react-resize-detector';

import CoupangPartners from '../../components/CoupangPartners/CoupangPartners';

import APIServer from '../../config/server.conf.json';

export default class Twitter extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      twitter_url_string: 'https://twitter.com/TheAcademy/status/1226730862735003650\nhttps://twitter.com/TheAcademy/status/1226719645849145344?s=20',
      twitter_url: [],
      twitter_result: [],
      playlist: []
    }
  }

  handleGetVideo = () => {
    let twitter_url = this.state.twitter_url_string.split('\n');

    fetch(`${APIServer.baseUrl}/api/v1/twitter/get`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: twitter_url.map(e => (
          /(https:\/\/.*twitter\.com\/.*\/status\/[^?|]+)/.exec(e)[1]
        ))
      })
    })
      .then(res => res.json())
      .then(res => {
        this.setState({
          twitter_url: twitter_url,
          twitter_result: res.data,
          playlist: res.data.filter(e => e.media.length > 0).map(e => ({ thumbnail: e.media[0].media_url, url: e.media[0].video_info[0].url, raw: e }))
        });
      })
  }

  render() {
    return (
      <Grid container spacing={5}>
        <Helmet
          title="트위터 동영상 다운로드"
          meta={[
            { name: "description", content: "트위터 동영상 다운로드" },
            { name: "keywords", content: "toolbox, tbx, 툴박스, twitter, twitter movie, twitter movie download, twitter mp4, twitter mp4 download, 트위터, 트위터 영상, 트위터 동영상, 트위터 영상 다운로드, 트위터 동영상 다운로드" },
            { property: "og:title", content: "트위터 동영상 다운로드 - TBX" },
            { property: "og:description", content: "트위터 동영상 다운로드 - TBX" },
            { property: "og:title", content: "트위터 동영상 다운로드 - TBX" },
          ]}
        />
        <Grid item xs={12}>
          <ReactResizeDetector handleWidth handleHeight>
            {({ width, height }) => <CoupangPartners width={width} height={height} />}
          </ReactResizeDetector>
        </Grid>
        <Grid item xs={12} lg={10}>
          <ExpansionPanel defaultExpanded variant="outlined">
            <ExpansionPanelSummary
              expandIcon={<ExpandMoreIcon/>}
            >
              twitter URL
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              <TextField
                fullWidth
                multiline
                rows='5'
                rowsMax='10'
                variant='outlined'
                value={this.state.twitter_url_string}
                onChange={(e) => this.setState({ twitter_url_string: e.target.value })}
                placeholder='https://twitter.com/TheAcademy/status/1226730862735003650'
              />
            </ExpansionPanelDetails>
            {/* <Divider /> */}
            <ExpansionPanelActions>
              <Button variant='contained' color='primary' onClick={this.handleGetVideo} disableElevation>
                Get Video
              </Button>
            </ExpansionPanelActions>
          </ExpansionPanel>
        </Grid>
        <Grid item xs={12} lg={10}>
          <Grid container spacing={2}>
            {this.state.playlist && this.state.playlist.map((e, i) => (
              <Grid item xs={12} md={6} lg={4} key={i}>
                <Card variant="outlined" style={{ display: 'flex' }}>
                  <CardMedia
                    style={{ width: 150, height: 150 }}
                    image={e.thumbnail}
                  />
                  <CardContent>
                    <Grid container direction="row" spacing={2}>
                      {e.raw.media[0].video_info.map((vie, vii) => (
                        <Grid item xs={12} md={6} key={vii}>
                          <Button
                            size="small"
                            variant="contained"
                            color={vii === 0 ? "primary":"default"}
                            href={vie.url}
                            target="new"
                            fullWidth
                            disableElevation
                          >
                            {vie.size}
                          </Button>
                        </Grid>
                      ))}
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
    );
  }
}